import { Environment } from "src/app/classes/flow/base/Environment";
import { ExtraPropertiesReferrerComponent } from "src/app/components/extra-properties-field/impl/extra-properties-referrer/extra-properties-referrer.component";

export const ENVIRONMENT: Environment = {
  PRODUCTION: false,
  ORGANISATION: "Fixteam",
  API_URL: "https://dev.api.epf.fixteamdrenthe.nl/",
  SOCIALS: {
    SLOGAN: "Wij hebben het zo voor u gefixt",
    LINKS: {
      MAIN: "https://fixteamdrenthe.nl/",
      PRIVACY: "https://fixteamdrenthe.nl/privacy-statement/",
      DISCLAIMER: "https://fixteamdrenthe.nl/disclaimer/",
    },
  },
  PORTAL_URL: "https://dev.portal.fixteamdrenthe.nl/",
  EXTRA_TRANSLATIONS_SUFFIX: [".fixteam"],
  MODULES: [
    "AREA_ACTIONS",
    "SHOW_ADDRESSDETAILS_TO_COACH_ROLE",
    "COACH_FINISH_REQUEST",
    "SHOW_ANOTHER_COACHES_ECS",
    "NOTE",
    "EDIT_ENERGY_CONSULT",
    "SHOW_CONTACT_INFO_ON_NEW_REQUESTS",
    "PHONE_NUMBER_REQUIRED",
    "MAIL_TIMELINE",
    "NEW_REQUEST_COACH",
    "NEW_REQUEST_COORDINATOR",
    "REPORT_CATEGORIES",
    "STATISTICS_DASHBOARD",
    "HIDE_AREA_ACTIONS_NEW_REQUEST_PAGE",
    "TIME_SLOTS_DAILY",
  ],
  AREA_OF_OPERATIONS: {
    MATCHES: [{ type: "include", key: "provincienaam", value: ["DRENTHE"] }],
  },
  CUSTOM_HEADER_LOGOS: [],
  ALLOWED_SPECIALTIES: [11],
  REDIRECTS: [],
  EXTRA_PROPERTIES_FIELDS: [ExtraPropertiesReferrerComponent],
};
